import { useCallback, useEffect, useState } from 'react';
import { useActiveVisitorsQuery } from '../../queries/useActiveVisitorsQuery';
import { isAvailable } from './types';
// Dynamic polling intervals based on visitor count
const POLLING_INTERVALS = {
    HIGH_TRAFFIC: 10_000, // 10s for >100 visitors
    MEDIUM_TRAFFIC: 30_000, // 30s for 10-100 visitors
    LOW_TRAFFIC: 60_000, // 60s for <10 visitors
};
const TRAFFIC_THRESHOLDS = {
    HIGH: 100,
    MEDIUM: 10,
};
export const useActiveVisitors = () => {
    const [pollingInterval, setPollingInterval] = useState(POLLING_INTERVALS.MEDIUM_TRAFFIC);
    const { activeVisitorsQuery } = useActiveVisitorsQuery(undefined, {
        refetchInterval: pollingInterval,
    });
    const visitorsCount = isAvailable(activeVisitorsQuery.data)
        ? activeVisitorsQuery.data.activeUsers
        : 0;
    const calculatePollingInterval = useCallback((count) => {
        if (count > TRAFFIC_THRESHOLDS.HIGH) {
            return POLLING_INTERVALS.HIGH_TRAFFIC;
        }
        if (count >= TRAFFIC_THRESHOLDS.MEDIUM) {
            return POLLING_INTERVALS.MEDIUM_TRAFFIC;
        }
        return POLLING_INTERVALS.LOW_TRAFFIC;
    }, []);
    useEffect(() => {
        if (activeVisitorsQuery.isFetched) {
            const interval = calculatePollingInterval(visitorsCount);
            setPollingInterval(interval);
        }
    }, [activeVisitorsQuery.isFetched, visitorsCount, calculatePollingInterval]);
    return {
        visitorsCount,
        available: isAvailable(activeVisitorsQuery.data),
    };
};
